import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "../common/Logo";
import { BrutalButton } from "../common/Brutal";

export const LandingCTA = () => (
  <>
    <section className="max-w-7xl mx-auto px-4 py-16">
      <div className="kf-border bg-[#E5247C] text-white p-8 sm:p-12 kf-shadow flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <div className="text-xs font-bold tracking-[0.3em] uppercase">Ready?</div>
          <h3 className="display text-4xl mt-2">Lock your slot before it’s gone.</h3>
          <p className="mt-2 text-white/90 max-w-lg">
            Zones are filling fast. Book in 60 seconds with GCash, Maya, or thru Bank Transfer.
          </p>
        </div>
        <Link to="/login" data-testid="cta-book-now">
          <BrutalButton variant="secondary" className="text-lg py-4 px-8">
            Book Now <ArrowRight className="h-5 w-5" />
          </BrutalButton>
        </Link>
      </div>
    </section>

    <footer className="border-t-2 border-[#3D1E6D] bg-white">
      <div className="max-w-7xl mx-auto px-4 py-8 flex items-center justify-between flex-wrap gap-4">
        <Logo size="sm" />
        <div className="text-xs font-bold uppercase tracking-widest text-[#6B4E9E]">
          kaogma.com · KAOGMA Grounds, Capitol Complex
        </div>
      </div>
    </footer>
  </>
);
